import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import React from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';

interface Props {
  collapsed: boolean;
}

export const ManagerPortalSidebar = ({ collapsed }: Props) => {
  const location = useLocation();

  return (
    <aside
      className={`attendance-tracking-sidebar${
        collapsed ? ' attendance-tracking-sidebar--collapsed' : ''
      }`}
      aria-label="Manager portal navigation"
    >
      <Sidebar
        collapsed={collapsed}
        backgroundColor="#ffffff"
        width="220px"
        collapsedWidth="72px"
        style={{ border: 'none', height: '100%' }}
      >
        <div className="attendance-tracking-sidebar__main">
          <div className="attendance-tracking-sidebar__menus">
            <div className="attendance-tracking-sidebar__heading">
              <span
                className="attendance-tracking-sidebar__heading-icon"
                aria-hidden
              >
                <SupervisorAccountOutlinedIcon fontSize="small" />
              </span>
              <span className="attendance-tracking-sidebar__heading-label">
                Manager Portal
              </span>
            </div>

            <Menu>
              <MenuItem
                icon={<img src="/icons/dashboard.svg" alt="" />}
                component={<Link to="/manager/attendance" />}
                active={location.pathname.startsWith('/manager/attendance')}
              >
                Attendance
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/list-check.svg" alt="" />}
                component={<Link to="/manager/leave-summary" />}
                active={location.pathname === '/manager/leave-summary'}
              >
                Leave Summary
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/summary_list.svg" alt="" />}
                component={<Link to="/manager/leave-approvals" />}
                active={location.pathname === '/manager/leave-approvals'}
              >
                Leave Approvals
              </MenuItem>
              <MenuItem
                icon={<img src="/icons/list-check.svg" alt="" />}
                component={<Link to="/manager/leave-allocation" />}
                active={location.pathname === '/manager/leave-allocation'}
              >
                Leave Allocation
              </MenuItem>
            </Menu>
          </div>
        </div>
      </Sidebar>
    </aside>
  );
};
